<template>
<b-modal id="rules-modal" title="Games Rules">
    <div class="modal-body text-center"> 
        <div class="row justify-content-center">
            <div class="col-12">
                <section class="content-block">
                    <header class="header">What is Hangman?</header>
                    <p>
                        Hangman wss originally a paper and pencil guessing game for two or more players. 
                        One player thinks of a word, phrase or sentence and the other(s) tries to guess it by suggesting letters or numbers, within a certain number of guesses.
                    </p>
                    <div>
                        <a href="https://en.wikipedia.org/wiki/Hangman_(game)" target="_blank">Wikipedia Explanation</a>
                    </div>
                </section>

                <section class="content-block mt-4">
                    <header class="header">How to play?</header>
                    <p>
                        Pick a game, and start guessing letters and ultimately, try to figure out the phrase or word.
                        It's that easy!
                    </p>
                    <p>
                        Please note, that you cannot play yourself. Your transaction will fail if you try. 
                    </p>
                </section>
            </div>
        </div>          
    </div>
    <div slot="modal-footer" class="modal-footer-inner">
        <button type="button" class="btn btn-secondary" @click="hideModal">
            Close
        </button>
    </div>
</b-modal>
</template>
 
<script>
import { mapGetters } from "vuex";

export default {
    name: "modal-rules",
    computed: {
        ...mapGetters({
            pendingTransaction: 'getPendingTransaction'
        })  
    },
    methods: {
        hideModal () {
            this.$root.$emit('bv::hide::modal','rules-modal');
        }
    }
};
</script>

<style scoped lang="less">
header {
    font-size: 16px;
    font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/components/ModalRules.vue